import {DatabaseCode, toDatabaseCode} from "./database-code";
import {TransportCategory} from "./transport-category";


export interface CargoSubtype extends DatabaseCode {
}

const water: CargoSubtype = {
  code: 'Water',
  displayValue: {
    id: 'ots.ui.entity.cargosubtype.water',
    defaultMessage: 'Water',
  },
};

const oil: CargoSubtype = {
  code: 'Oil',
  displayValue: {
    id: 'ots.ui.entity.cargosubtype.oil',
    defaultMessage: 'Oil',
  },
};

const chemicals: CargoSubtype = {
  code: 'Chemicals',
  displayValue: {
    id: 'ots.ui.entity.cargosubtype.chemicals',
    defaultMessage: 'Chemicals',
  },
};

const waste: CargoSubtype = {
  code: 'Waste',
  displayValue: {
    id: 'ots.ui.entity.entity.dispatch.status.waste',
    defaultMessage: 'Waste',
  },
};

const tank: CargoSubtype = {
  code: 'Tank',
  displayValue: {
    id: 'ots.ui.entity.cargosubtype.tank',
    defaultMessage: 'Tank',
  },
};

export const cargoSubtype = {
  water,
  oil,
  chemicals,
  waste,
  tank,
};

export const cargoSubtypes = Object.values(cargoSubtype);

export const toCargoSubtype = (code: string): TransportCategory => toDatabaseCode(code, cargoSubtypes);
